import VbDatePicker from './src/index.vue'

VbDatePicker.install = function (Vue) {
  Vue.component(VbDatePicker.name, VbDatePicker)
}

export default VbDatePicker
